import type { NativeToolbarViewProps } from './types';

export const NativeToolbarView: React.FC<NativeToolbarViewProps> = () => null;
